import React, { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { Switch } from "@headlessui/react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import { MdPrint } from "react-icons/md";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { baseUrl } from "../../Environments/environment";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tick from "../../Assets/Tick.Svg";
import countries from "../../utils/countries";
import { apiClient } from "../../api";
//added comment
const statuses = [
	"Bookings",
	"Check In",
	"In House",
	"Check Out",
	"Checked Out",
];

const mapStatus = {
	Booking: "Reservation",
	"Check In": "Reservation",
	"In House": "In House",
	"Check Out": "In House",
	"Checked Out": "Checked Out",
};

const reverseMapStatus = {
	Reservation: "Booking",
	"In House": "In House",
	"Checked Out": "Checked Out",
	Cancelled: "Cancelled",
};
function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}
const UpdateGuestModal = ({ guest, onClose }) => {
	const dropdownRef = useRef(null);
	const searchInputRef = useRef(null);
	const { accessToken } = useAuth();
	const { selectedPropertyId } = useProperty();
	const guestId = guest._id;
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	//const [countryCode, setCountryCode] = useState("");
	const [confirmationNumber, setConfirmationNumber] = useState("");
	const [roomNumber, setRoomNumber] = useState("");
	const [arrivalDate, setArrivalDate] = useState("");
	const [departureDate, setDepartureDate] = useState("");
	const [loading, setLoading] = useState(false);
	const [source, setSource] = useState("");
	// const [draft, setDraft] = useState(false);
	const [currentStatus, setCurrentStatus] = useState("");
	const [selectedCountry, setSelectedCountry] = useState("");
	const [countryCode, setCountryCode] = useState("+1");
	const [searchTerm, setSearchTerm] = useState("");
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	// const [reservationStatus, setReservationStatus] = useState("");
	// New state variables for registration details
	const [checkInType1, setCheckInType1] = useState("");
	const [checkInType2, setCheckInType2] = useState("");
	const [arrivalTime, setArrivalTime] = useState("");
	const [departureTime, setDepartureTime] = useState("");
	const [isPreArrivalExpanded, setPreArrivalExpanded] = useState(false);
	const [clickedButton, setClickedButton] = useState({
		text: "",
		id: "",
	});
	const [isAddOnsExpanded, setAddOnsExpanded] = useState(false);
	const [isAddOnLoading, setIsAddOnLoading] = useState({
		loading: false,
		id: "",
	});
	const [isCustomAddOnLoading, setIsCustomAddOnLoading] = useState({
		loading: false,
		id: "",
	});
	const [checkInOutRequests, setCheckInOutRequests] = useState([]);
	const [printProofUrl, setPrintProofUrl] = useState(null);
	const [isPrinting, setIsPrinting] = useState(false);
	const [preArrival, setPreArrival] = useState({
		_id: "",
		guestId: "",
		propertyId: "",
		phoneNumber: "",
		emailAddress: "",
		arrivalTime: "",
		vehicleMakeModelColor: "",
		licensePlateNo: "",
		specialRequests: "",
		guestSignatureUrl: "",
		guestIdProofUrl: "",
		policyAccepted: false,
		consentToText: false,
	});

	const [addOns, setAddOns] = useState({
		statusCounts: {
			Requested: 0,
			Declined: 0,
			Accepted: 0,
		},
		addOnsRequests: [],
	});

	const togglePreArrivalExpansion = () => {
		setPreArrivalExpanded((prevState) => !prevState);
	};

	const toggleAddOnsExpansion = () => {
		setAddOnsExpanded((prevState) => !prevState);
	};

	useEffect(() => {
		const fetchGuestData = async () => {
			setLoading(true);

			try {
				const response = await apiClient.get(
					`${baseUrl}/guest/getGuestData/${selectedPropertyId}/${guestId}`,
					// `https://h13p3wh7-4000.inc1.devtunnels.ms/guest/getGuestData/66a2125d50a317d5ffa691ad/66c72f7c8610d881b822af99`,
					{
						headers: {
							Authorization: `Bearer ${accessToken}`,
						},
					},
				);

				// Extract and set 'preArrival' and 'addOns' from the response
				const { preArrival, addOns, checkInOutRequest } = response.data.result;
				console.log("response", response.data.result);
				setPreArrival(preArrival);
				setAddOns(addOns);
				setCheckInOutRequests(checkInOutRequest);
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to fetch guest data. Please try again.";
				toast.error(errorMessage);
			} finally {
				setLoading(false);
			}
		};

		fetchGuestData();
	}, [accessToken, selectedPropertyId, guestId]);

	useEffect(() => {
		const handleAfterPrint = () => {
			setIsPrinting(false);
			setPrintProofUrl(null);
		};
		window.addEventListener("afterprint", handleAfterPrint);
		return () => window.removeEventListener("afterprint", handleAfterPrint);
	}, []);

	const handlePrintIdProof = () => {
		const proofUrl = preArrival?.guestIdProofUrl;
		if (!proofUrl) {
			toast.error("No ID proof available.");
			return;
		}
		setPrintProofUrl(proofUrl);
		setIsPrinting(true);
	};
	// Fetch guest data when modal opens
	useEffect(() => {
		if (guest) {
			// Extract and set the date and time values for check-in and check-out
			const parseDateTime = (dateTimeString) => {
				if (!dateTimeString) return { date: "", time: "" };

				const date = new Date(dateTimeString);

				// Format date as YYYY-MM-DD
				const dateString = date.toISOString().split("T")[0];

				// Format time as HH:MM
				const timeString = date.toISOString().split("T")[1].substring(0, 5);

				return { date: dateString, time: timeString };
			};

			// Example usage
			const checkIn = parseDateTime(guest.checkIn);
			const checkOut = parseDateTime(guest.checkOut);
			setFirstName(guest.firstName || "");
			setLastName(guest.lastName || "");
			setEmail(guest.email || "");
			setPhoneNumber(guest.phoneNumber || "");
			setCountryCode(guest.countryCode || "");
			if (guest.countryCode)
				setSelectedCountry(() => {
					return { ...selectedCountry, code: guest.countryCode };
				});
			setConfirmationNumber(guest.confirmationNumber || "");
			setRoomNumber(guest.roomNumber || "");
			setArrivalDate(checkIn.date);
			setArrivalTime(checkIn.time);
			setDepartureDate(checkOut.date);
			setDepartureTime(checkOut.time);
			setSource(guest.source || "");
			setCurrentStatus(guest.status?.currentStatus || "");
			//setDraft(guest.draft);
			//setReservationStatus(guest.status?.reservationStatus || "");

			setCheckInType1(guest.checkInType1 || ""); // Default to '' if not present
			setCheckInType2(guest.checkInType2 || ""); // Default to '' if not present
		}
		console.log("guest", guest);
	}, [guest, selectedCountry]);
	const cleanGuestData = (data) => {
		if (!data || Object.keys(data).length === 0) return {};

		return {
			firstName: data.firstName || null,
			lastName: data.lastName || null,
			...(data.email && data.email.trim().length > 0 && { email: data.email }),
			countryCode: !phoneNumber ? undefined : countryCode,
			phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
			...(data.confirmationNumber && {
				confirmationNumber: data.confirmationNumber,
			}),
			...(data.roomNumber && {
				roomNumber: data.roomNumber,
			}),
			//draft: !phoneNumber ? true : draft,
			checkIn: data.checkIn || null,
			checkOut: data.checkOut || null,
			...(data.source &&
				data.source.trim().length > 0 && { source: data.source }),
		};
	};
	let earlyCheckInStatus, reservationStatus, lateCheckOutStatus;
	if (checkInType1 === "Early Check In") {
		earlyCheckInStatus = "Accepted";
	}
	if (checkInType1 === "Cancel Reservation") {
		reservationStatus = "Cancelled";
	}
	if (checkInType1 === "No Show") {
		reservationStatus = "No Show";
	}
	if (checkInType2 === "Late Check Out") {
		lateCheckOutStatus = "Accepted";
	}
	const status = Object.fromEntries(
		Object.entries({
			earlyCheckInStatus,
			reservationStatus,
			lateCheckOutStatus,
		}).filter(
			([_, value]) => value !== undefined && value !== null && value !== "",
		),
	);

	// Now `status` will only contain properties with valid values.

	const cleanPreArrivalData = (data) => {
		if (!data || Object.keys(data).length === 0) return {};

		return {
			phoneNumber: data.phoneNumber || null,
			emailAddress: data.emailAddress || null,
			arrivalTime: data.arrivalTime || null,
			vehicleMakeModelColor: data.vehicleMakeModelColor || null,
			licensePlateNo: data.licensePlateNo || null,
			specialRequests: data.specialRequests || null,
			guestSignatureUrl: data.guestSignatureUrl || null,
			guestIdProofUrl: data.guestIdProofUrl || null,
			policyAccepted:
				data.policyAccepted !== undefined ? data.policyAccepted : null,
			consentToText:
				data.consentToText !== undefined ? data.consentToText : null,
		};
	};
	const handleUpdateGuest = async () => {
		setLoading(true); // Optional: set loading state if you have a loading indicator

		// Format check-in and check-out dates and times
		const checkIn = `${arrivalDate}T${arrivalTime}Z`;
		const checkOut = `${departureDate}T${departureTime}Z`;

		const updatedGuestData = {
			guest: cleanGuestData({
				firstName,
				lastName,
				email,
				phoneNumber,
				countryCode,
				confirmationNumber,
				roomNumber,
				checkIn,
				checkOut,
				source,
			}),
			status,
			preArrival: cleanPreArrivalData(preArrival),
			// addOns: {
			//   statusCounts: addOns.statusCounts,
			//   addOnsRequests: addOns.addOnsRequests,
			// },
			// checkInOutRequest: checkInOutRequests,
		};

		try {
			// Make the PATCH request to update guest information
			const response = await apiClient.patch(
				`${baseUrl}/guest/guestedit/${selectedPropertyId}/${guest._id}`,
				updatedGuestData,
				{
					headers: {
						Authorization: `Bearer ${accessToken}`,
						"Content-Type": "application/json",
					},
					withCredentials: true,
				},
			);

			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}

			if (response.status === 200) {
				toast.success("Guest updated successfully!");
				onClose();
			} else {
				toast.error("Failed to update guest. Please try again.");
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Error updating guest. Please try again.";
			toast.error(errorMessage);
		} finally {
			setLoading(false); // Optional: reset loading state
		}
	};

	const handleStatusChange = async (status, id) => {
		const url = `${baseUrl}/checkInOutRequest/${selectedPropertyId}/${guestId}/${id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};

		try {
			setIsAddOnLoading({ ...isAddOnLoading, loading: true });
			const response = await apiClient.patch(url, updatedStatus, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
				withCredentials: true,
			});

			setIsAddOnLoading({ ...isAddOnLoading, loading: false });
			setCheckInOutRequests(
				checkInOutRequests.map((req) => {
					if (req._id === id) {
						return { ...req, requestStatus: status };
					}
					return req;
				}),
			);

			toast.success(`Status updated to ${status}`);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsAddOnLoading({ ...isAddOnLoading, loading: false });
		}
	};
	const handleCustomAddonStatusChange = async (status, id) => {
		const url = `${baseUrl}/addOnsRequest/${selectedPropertyId}/${guestId}/${id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};
		try {
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: true,
			});
			const response = await apiClient.put(url, updatedStatus, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
				withCredentials: true,
			});
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			toast.success(`Status updated to ${status}`);
			setAddOns({
				...addOns,
				addOnsRequests: addOns.addOnsRequests.map((addon) => {
					if (addon._id === id) {
						return { ...addon, requestStatus: status };
					}
					return addon;
				}),
			});
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: false,
			});
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: false,
			});
		}
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			// Check if click is outside both the dropdown and the trigger button
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
				setSearchTerm("");
			}
		};

		// Only add the event listener if the dropdown is open
		if (isDropdownOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isDropdownOpen]);
	const toggleDropdown = (e) => {
		e.stopPropagation();
		setIsDropdownOpen(!isDropdownOpen);
		if (!isDropdownOpen) {
			// Reset search when opening
			setSearchTerm("");
			// Focus search input after opening
			setTimeout(() => {
				searchInputRef.current?.focus();
			}, 0);
		}
	};
	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
	};

	const filteredCountries = countries.filter((country) =>
		country.name.toLowerCase().includes(searchTerm.toLowerCase()),
	);

	const handleCountrySelect = (country) => {
		setSelectedCountry(country);
		setCountryCode(country.code);
		setSearchTerm(""); // Clear search term on selection
		setIsDropdownOpen(false); // Close the dropdown
	};

	const handleClearSelection = () => {
		setSelectedCountry(null); // Clear the selected country
		setSearchTerm(""); // Clear the search term
	};

	return (
		<>
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
				{loading && <LoadingSpinner />}
				<div className="bg-white p-6 rounded-lg shadow-xl lg:w-[80vh] h-[90vh] overflow-auto space-y-2">
					{/* Headings  */}
					<div className="flex justify-between items-start">
						{/* Left Section with heading and guest info */}
						<div className="flex flex-col space-y-1 w-full">
							{/* Title and Guest Info */}
							<div className="flex items-center space-x-4">
								<h2 className="text-lg font-semibold">Update Guest</h2>

								<div className="text-lg text-gray-600">
									{firstName && lastName && (
										<span>{`${firstName} ${lastName}`}</span>
									)}
									{<span>{` - ${roomNumber}`}</span>}
								</div>
							</div>

							{/* Status and Button Section */}
							<div className="flex pt-4 w-full items-center justify-between">
								{/* Status Text */}
								<div className="flex flex-col">
									<span className="text-xs text-gray-700">Status</span>
									<span className="text-lg font-semibold">
										{reverseMapStatus[currentStatus]}
									</span>
								</div>
								<div className="flex-shrink-0">
									<button
										onClick={handleUpdateGuest}
										className="px-4 py-1 w-full rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
									>
										Save changes
									</button>
								</div>
							</div>
						</div>

						{/* Close Button */}
						<div className="flex flex-col items-end">
							<button
								onClick={onClose}
								className="text-gray-600 hover:text-gray-900 mb-4"
							>
								<AiOutlineClose size={24} />
							</button>
						</div>
					</div>

					{/* Pre-arrival Section */}
					<div className="pt-2">
						<div className="flex items-center justify-between bg-gray-200 px-2 py-2 rounded-lg">
							<h3 className="text-sm font-semibold">Pre-arrival</h3>
							<button
								onClick={togglePreArrivalExpansion}
								className="text-indigo-600 hover:text-indigo-800 text-sm font-semibold"
							>
								{isPreArrivalExpanded ? (
									<HiChevronUp className="inline-block w-5 h-5" />
								) : (
									<HiChevronDown className="inline-block w-5 h-5" />
								)}
							</button>
						</div>

						{isPreArrivalExpanded && preArrival && (
							<div className="mt-2 text-gray-700 bg-gray-50 p-2 rounded-md">
								{/* Pre-arrival Content */}
								<div className="flex mb-4">
									<div className="w-1/2 pr-2">
										<label className="text-gray-700 text-sm font-bold mb-2">
											Vehicle Make / Model / Color
										</label>
										<input
											type="text"
											name="vehicleMakeModelColor"
											value={preArrival.vehicleMakeModelColor}
											onChange={(e) =>
												setPreArrival({
													...preArrival,
													vehicleMakeModelColor: e.target.value,
												})
											}
											className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
										/>
									</div>
									<div className="w-1/2 pl-2">
										<label className="text-gray-700 text-sm font-bold mb-2">
											License Plate #
										</label>
										<input
											type="text"
											name="licensePlateNo"
											value={preArrival.licensePlateNo}
											onChange={(e) =>
												setPreArrival({
													...preArrival,
													licensePlateNo: e.target.value,
												})
											}
											className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
										/>
									</div>
								</div>

								<div className="mb-4">
									<label className="text-gray-700 text-sm font-bold mb-2">
										Special Requests
									</label>
									<textarea
										name="specialRequests"
										value={preArrival.specialRequests}
										onChange={(e) =>
											setPreArrival({
												...preArrival,
												specialRequests: e.target.value,
											})
										}
										className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
									/>
								</div>

								<div className="mb-4">
									<label className="flex flex-col items-baseline">
										<span
											className={`font- mb-1 ${
												preArrival.policyAccepted
													? "text-green-400"
													: "text-red-400"
											}`}
										>
											{preArrival.policyAccepted ? "Agreed" : "Disagreed"}
										</span>
										<span className="text-gray-700">
											I have read and agree to the above policies.
										</span>
									</label>
								</div>

								<div className="mb-4">
									<label className="flex flex-col items-baseline">
										<span
											className={`font- mb-1 ${
												preArrival.consentToText
													? "text-green-400"
													: "text-red-400"
											}`}
										>
											{preArrival.consentToText ? "Agreed" : "Disagreed"}
										</span>
										<span className="text-gray-700">
											I consent to receive texts and emails related to my stay
											and future marketing materials.
										</span>
									</label>
								</div>
								{/* Guest Signature and ID Proof - Side by Side */}
								<div className="mb-4">
									<div className="flex space-x-4">
										{/* Guest Signature */}
										<div className="w-1/2">
											<label className="text-gray-700 text-sm font-bold mb-2">
												Guest Signature
											</label>
											{preArrival.guestSignatureUrl ? (
												<img
													src={preArrival.guestSignatureUrl}
													alt="Guest Signature"
													className="w-full h-64 object-contain border border-gray-300 rounded bg-white"
												/>
											) : (
												<p className="text-sm text-gray-500">
													No signature available
												</p>
											)}
										</div>

										{/* Guest ID Proof */}
										<div className="w-1/2">
											<div className="flex items-center justify-between">
												<label className="text-gray-700 text-sm font-bold mb-2">
													Guest ID Proof
												</label>
												{preArrival.guestIdProofUrl && (
													<button
														className="text-indigo-600 hover:text-indigo-800"
														onClick={handlePrintIdProof}
														title="Print ID Proof"
														aria-label="Print ID Proof"
													>
														<MdPrint size={18} />
													</button>
												)}
											</div>
											{preArrival.guestIdProofUrl ? (
												<div className="relative">
													<img
														src={preArrival.guestIdProofUrl}
														alt="Guest ID Proof"
														className="w-full h-64 object-contain border border-gray-300 rounded bg-white"
													/>
													{/* Guest Name Overlay at bottom */}
													<div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-white p-2 rounded-b">
														<p className="text-sm font-medium">
															{firstName} {lastName}
														</p>
													</div>
												</div>
											) : (
												<p className="text-sm text-gray-500">
													No ID proof available
												</p>
											)}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>

					{/* Add-ons Section */}
					<div className="mt-4">
						<div className="flex items-center justify-between bg-gray-200 px-2 py-2 rounded-lg">
							<h3 className="text-sm font-semibold">Add-ons</h3>
							<button
								onClick={toggleAddOnsExpansion}
								className="text-indigo-600 hover:text-indigo-800 text-sm font-semibold"
							>
								{isAddOnsExpanded ? (
									<HiChevronUp className="inline-block w-5 h-5" />
								) : (
									<HiChevronDown className="inline-block w-5 h-5" />
								)}
							</button>
						</div>

						{isAddOnsExpanded && (
							<div className="mt-2 text-gray-700 bg-gray-50 p-2 rounded-md">
								{addOns.addOnsRequests.length > 0 &&
									addOns.addOnsRequests.map((addon, index) => (
										<div
											key={addon._id}
											className="mb-4 p-4 bg-white shadow-md rounded-lg"
										>
											{/* Add-on Information */}
											<div className="flex justify-between items-start">
												<div>
													<h4 className="text-sm font-bold text-gray-800">
														{addon.name}
													</h4>
													<p className="text-gray-600">{addon.description}</p>
												</div>
												{/* Price */}
												<div className="text-right">
													<p className="text-gray-800 font-bold">
														${addon.price}
													</p>
												</div>
											</div>

											{/* Status and Actions */}
											<div className="flex justify-between items-center mt-2">
												{addon.requestStatus === "Requested" ? (
													<div className="w-full flex flex-row">
														{/* Accept Button */}
														{(!clickedButton.id ||
															clickedButton.text !== "Declined" ||
															clickedButton.id !== addon._id) && (
															<button
																onClick={() => {
																	handleCustomAddonStatusChange(
																		"Accepted",
																		addon._id,
																	);
																	setIsCustomAddOnLoading({
																		loading: true,
																		id: addon._id,
																	});
																	setClickedButton({
																		text: "Accepted",
																		id: addon._id,
																	});
																}}
																className="w-1/2 text-green-700 border-green-700 border-2 bg-green-100 hover:bg-green-600 hover:text-white px-3 py-1 rounded-md mr-2"
															>
																{isCustomAddOnLoading.id === addon._id &&
																isCustomAddOnLoading.loading &&
																clickedButton.text === "Accepted"
																	? "Please Wait..."
																	: "Accept"}
															</button>
														)}

														{/* Decline Button */}
														{(!clickedButton.id ||
															clickedButton.text !== "Accepted" ||
															clickedButton.id !== addon._id) && (
															<button
																onClick={() => {
																	handleCustomAddonStatusChange(
																		"Declined",
																		addon._id,
																	);
																	setIsCustomAddOnLoading({
																		loading: true,
																		id: addon._id,
																	});
																	setClickedButton({
																		text: "Declined",
																		id: addon._id,
																	});
																}}
																className="w-1/2 text-red-700 border-red-600 bg-red-100 border-2 hover:bg-red-600 hover:text-white px-3 py-1 rounded-md"
															>
																{isCustomAddOnLoading.id === addon._id &&
																isCustomAddOnLoading.loading &&
																clickedButton.text === "Declined"
																	? "Please Wait..."
																	: "Decline"}
															</button>
														)}
													</div>
												) : (
													<p
														className={`flex flex-row justify-center items-center gap-2 w-full text-center border-2  px-3 py-1 rounded-md font- ${
															addon.requestStatus === "Accepted"
																? "text-green-700 border-green-700 bg-green-100"
																: "text-red-700 border-red-600 bg-red-100"
														}`}
													>
														{addon.requestStatus === "Accepted" ? (
															<img alt="" src={Tick} className="h-4" />
														) : (
															<div className="h-4 w-4 bg-red-600 flex justify-center  items-center rounded-full">
																<RxCross2 color="white" size="24" />
															</div>
														)}
														{addon.requestStatus}
													</p>
												)}
											</div>
										</div>
									))}
								{checkInOutRequests &&
									checkInOutRequests.length > 0 &&
									checkInOutRequests.map((addon, index) => (
										<div
											key={addon._id}
											className="mb-4 p-4 bg-white shadow-md rounded-lg"
										>
											{/* Add-on Information */}
											<div className="flex justify-between items-start">
												<div>
													<h4 className="text-sm font-bold text-gray-800">
														{addon.requestType === "earlyCheckIn"
															? `Early Check In for ${new Date(
																	addon.earlyCheckInDateTime,
																).toLocaleString("en", {
																	day: "2-digit",
																	month: "2-digit",
																	hour: "2-digit",
																	minute: "2-digit",
																	hour12: true,

																	timeZone: "UTC",
																})}`
															: addon.requestType === "lateCheckOut"
																? `Late Check Out ${new Date(
																		addon.lateCheckOutDateTime,
																	).toLocaleString("en", {
																		day: "2-digit",
																		month: "2-digit",
																		hour: "2-digit",
																		minute: "2-digit",
																		hour12: true,
																		timeZone: "UTC",
																	})}`
																: addon.requestType === "extendStay"
																	? `Extend saty till  ${new Date(
																			addon.extendStayDateTime,
																		).toLocaleString("en", {
																			day: "2-digit",
																			month: "2-digit",
																		})}`
																	: ""}
													</h4>
												</div>
												{/* Price */}
												<div className="text-right">
													<p className="text-gray-800 font-bold">
														{addon && addon.addOnDetails
															? `${addon.addOnDetails.price}`
															: ""}
													</p>
												</div>
											</div>

											{/* Status and Actions */}
											<div className="flex justify-between items-center mt-2">
												{addon.requestStatus === "Requested" ? (
													<div className="w-full flex fexl-row">
														{(!clickedButton.id ||
															clickedButton.text !== "Declined" ||
															clickedButton.id !== addon._id) && (
															<button
																onClick={() => {
																	// const updatedRequests = checkInOutRequests.map(
																	//   (request) =>
																	//     request._id === addon._id
																	//       ? {
																	//           ...request,
																	//           requestStatus: "Accepted",
																	//         }
																	//       : request
																	// );
																	// setCheckInOutRequests(updatedRequests);
																	handleStatusChange("Accepted", addon._id);
																	setIsAddOnLoading({
																		loading: true,
																		id: addon._id,
																	});
																	setClickedButton({
																		text: "Accepted",
																		id: addon._id,
																	});
																}}
																className="w-1/2 text-green-700 border-green-700 bg-green-100 hover:bg-green-600 hover:text-white  px-3 py-1 rounded-md mr-2"
															>
																{isAddOnLoading.id == addon._id &&
																isAddOnLoading.loading
																	? "Please Wait..."
																	: "Accept"}
															</button>
														)}
														{(!clickedButton.id ||
															clickedButton.text !== "Accepted" ||
															clickedButton.id !== addon._id) && (
															<button
																onClick={() => {
																	// const updatedRequests = checkInOutRequests.map(
																	//   (request) =>
																	//     request._id === addon._id
																	//       ? {
																	//           ...request,
																	//           requestStatus: "Declined",
																	//         }
																	//       : request
																	// );
																	// setCheckInOutRequests(updatedRequests);
																	handleStatusChange("Declined", addon._id);
																	setIsAddOnLoading({
																		loading: true,
																		id: addon._id,
																	});
																	setClickedButton({
																		text: "Declined",
																		id: addon._id,
																	});
																}}
																className="w-1/2  text-red-700 border-red-600 bg-red-100 border-2  hover:bg-red-600 hover:text-white px-3 py-1 rounded-md"
															>
																{isAddOnLoading.id == addon._id &&
																isAddOnLoading.loading
																	? "Please Wait..."
																	: "Decline"}
															</button>
														)}
													</div>
												) : (
													<p
														className={`flex flex-row justify-center items-center gap-2 w-full text-center border-2  px-3 py-1 rounded-md font- ${
															addon.requestStatus === "Accepted"
																? "text-green-700 border-green-700 bg-green-100"
																: "text-red-700 border-red-600 bg-red-100"
														}`}
													>
														{addon.requestStatus === "Accepted" ? (
															<img alt="" src={Tick} className="h-4" />
														) : (
															<div className="h-4 w-4 bg-red-600 flex justify-center  items-center rounded-full">
																<RxCross2 color="white" size="24" />
															</div>
														)}
														{addon.requestStatus}
													</p>
												)}
											</div>
										</div>
									))}
							</div>
						)}
					</div>

					{/* Update form */}
					<div className="w-full space-y-5 pb-4 pt-4">
						<div className="flex space-x-4">
							<div className="w-1/2">
								<label className="block text-[13px] font-semibold mb-1 text-gray-700">
									First Name
								</label>
								<input
									type="text"
									value={firstName}
									onChange={(e) => setFirstName(e.target.value)}
									className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[15px] placeholder:text-gray-400 placeholder:font-light"
								/>
							</div>
							<div className="w-1/2">
								<label className="block text-[13px] font-semibold mb-1 text-gray-700">
									Last Name
								</label>
								<input
									type="text"
									value={lastName}
									onChange={(e) => setLastName(e.target.value)}
									className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[15px] placeholder:text-gray-400 placeholder:font-light"
								/>
							</div>
						</div>

						<div className="space-y-4 w-full max-w-2xl">
							<div className="space-y-2">
								<label className="block text-sm font-medium text-gray-700">
									Phone Number
								</label>
								<div className="relative">
									<div className="flex">
										<div className="relative w-[120px]">
											<button
												type="button"
												onClick={toggleDropdown}
												className="w-full h-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-l-md text-sm hover:bg-gray-50"
											>
												<span className="flex items-center gap-2">
													{selectedCountry ? (
														<>
															<span>{selectedCountry.code}</span>
														</>
													) : (
														"+1"
													)}
												</span>
												<svg
													className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
														isDropdownOpen ? "rotate-180" : ""
													}`}
													viewBox="0 0 20 20"
													fill="currentColor"
												>
													<path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
												</svg>
											</button>
										</div>
										<input
											type="tel"
											value={phoneNumber}
											onChange={(e) => setPhoneNumber(e.target.value)}
											placeholder="Enter phone number"
											className="flex-1 rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
										/>
									</div>

									{/* Dropdown */}
									{isDropdownOpen && (
										<div
											ref={dropdownRef}
											className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
										>
											<div className="p-2">
												<input
													ref={searchInputRef}
													type="text"
													value={searchTerm}
													onChange={(e) => setSearchTerm(e.target.value)}
													placeholder="Search country..."
													className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
												/>
											</div>
											<div className="max-h-60 overflow-y-auto">
												{filteredCountries.map((country) => (
													<div
														key={country.code}
														className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3 text-sm"
														onClick={() => handleCountrySelect(country)}
													>
														<span className="text-lg">{country.flag}</span>
														<span className="text-gray-700">
															{country.name}
														</span>
														<span className="text-gray-500 ml-auto">
															{country.code}
														</span>
													</div>
												))}
												{filteredCountries.length === 0 && (
													<div className="px-4 py-2 text-sm text-gray-500">
														No countries found
													</div>
												)}
											</div>
										</div>
									)}
								</div>
							</div>

							<div className="space-y-2">
								<label className="block text-sm font-medium text-gray-700">
									Email
								</label>
								<input
									type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder="Enter your email"
									className="w-full rounded-md border border-gray-300 
                   px-3 py-2 text-sm text-gray-700 
                   focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                   placeholder:text-gray-400"
								/>
							</div>
						</div>
						{/* <div className="flex flex-row justify-between items-center my-2">
              <label
                htmlFor="toggle"
                className="text-[13px] font-medium text-[#111827]"
              >
                Draft
              </label>
              <Switch
                checked={draft}
                onChange={setDraft}
                className={classNames(
                  draft ? "bg-indigo-600" : "bg-gray-200",
                  "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                )}
              >
                <span
                  aria-hidden="true"
                  className={classNames(
                    draft ? "translate-x-5" : "translate-x-0",
                    "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                  )}
                />
              </Switch>
            </div> */}

						{/* Registration Details */}
						<div className="">
							<label className="block text-[13px] font-semibold text-gray-700 mb-1">
								Registration Details
							</label>

							<div className="flex">
								<div className="w-1/2">
									<select
										value={checkInType1}
										onChange={(e) => setCheckInType1(e.target.value)}
										placeholder="Check In Type"
										className={`block w-full border border-b-0 rounded-tl-md border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light ${
											checkInType1 === "Cancel Reservation" &&
											checkInType1 === "No Show" &&
											currentStatus !== "Checked Out"
												? "bg-rose-50"
												: ""
										}`}
									>
										<option value="Check In">Check In</option>
										<option value="Early Check In">Early Check In</option>
										{currentStatus !== "Checked Out" && (
											<>
												<option value="Cancel Reservation">
													Cancel Reservation
												</option>
												<option value="No Show">No Show</option>
											</>
										)}
									</select>
								</div>
								<div className="w-1/2">
									<select
										value={checkInType2}
										onChange={(e) => setCheckInType2(e.target.value)}
										placeholder="Check Out Type"
										className="block w-full border border-b-0 rounded-tr-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light"
									>
										<option value="Check Out">Check Out</option>
										<option value="Late Check Out">Late Check Out</option>
									</select>
								</div>
							</div>

							<div className="flex">
								<div className="w-1/4">
									<input
										type="date"
										id="arrivalDate"
										value={arrivalDate}
										onChange={(e) => {
											const newArrival = e.target.value;
											setArrivalDate(newArrival);

											setDepartureDate(
												new Date(newArrival) >= new Date(departureDate)
													? new Date(
															new Date(newArrival).getTime() +
																24 * 60 * 60 * 1000,
														)
															.toISOString()
															.split("T")[0]
													: departureDate,
											);
										}}
										className={`block w-full border border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] ${
											checkInType1 === "Early Check In"
												? "text-gray-900"
												: "text-gray-400"
										}`}
									/>
								</div>
								<div className="w-1/4">
									<input
										type="time"
										id="arrivalTime"
										value={arrivalTime}
										disabled={checkInType1 === "Check In"}
										onChange={(e) => setArrivalTime(e.target.value)}
										className={`block w-full border border-l-0 border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light ${
											checkInType1 === "Early Check In"
												? "text-gray-900"
												: "text-gray-400"
										}`}
									/>
								</div>
								<div className="w-1/4">
									<input
										type="date"
										id="departureDate"
										value={departureDate}
										onChange={(e) => setDepartureDate(e.target.value)}
										className={`block w-full border border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
											checkInType2 === "Check Out"
												? "text-gray-400"
												: "text-gray-900"
										}`}
									/>
								</div>
								<div className="w-1/4">
									<input
										type="time"
										id="departureTime"
										value={departureTime}
										onChange={(e) => setDepartureTime(e.target.value)}
										disabled={
											checkInType2 === "Check Out" &&
											checkInType1 !== "Cancel Reservation" &&
											checkInType1 !== "No Show"
										}
										className={`block w-full border border-l-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] placeholder:text-gray-300 placeholder:font-light ${
											checkInType2 === "Check Out"
												? "text-gray-400"
												: "text-gray-900"
										}`}
									/>
								</div>
							</div>

							<div className="flex">
								<div className="w-1/2">
									<input
										type="text"
										value={confirmationNumber}
										onChange={(e) => setConfirmationNumber(e.target.value)}
										className="block w-full border border-t-0 border-r-0 rounded-bl-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-400 placeholder:font-light"
										placeholder="Confirmation number"
									/>
								</div>
								<div className="w-1/2">
									<select
										value={source}
										onChange={(e) => setSource(e.target.value)}
										placeholder="Source"
										className="block w-full border border-t-0 rounded-br-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light"
									>
										<option value="" style={{ color: "#9e9e9e" }}>
											Select source
										</option>
										<option value="booking">Booking.com</option>
										<option value="expedia">Expedia</option>
										<option value="airbnb">Airbnb</option>
										<option value="google">Google</option>
										<option value="ctrip">C-Trip</option>
										<option value="hotels">Hotels.com</option>
										<option value="HotelsWebsite">Hotels website</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{isPrinting && (
				<div id="print-id-proof-modal">
					<style>{`@media print { body * { visibility: hidden; } #print-id-proof-modal, #print-id-proof-modal * { visibility: visible; } #print-id-proof-modal { position: fixed; inset: 0; } img { max-width: 100%; max-height: 100vh; object-fit: contain; } }`}</style>
					<img
						src={printProofUrl || ""}
						alt="Guest ID Proof"
						onLoad={() => window.print()}
					/>
				</div>
			)}
		</>
	);
};

export default UpdateGuestModal;
